import type { GrainBin } from "@/api/types";

/**
 * ef-063-1c-c — the ONE rule for how a grain bin reads in a picker. A farm bin keeps its plain
 * name; an elevator bin reads `{name} (at {vendorName})` so a person choosing where grain goes
 * (the harvest form's "Store in bin", the delivery form's "Bin") can tell off-farm storage from
 * a bin on the farm. Shared by `Grain.tsx` and `Fields.tsx` so the two pickers cannot drift.
 */
export function grainBinLabel(bin: Pick<GrainBin, "name" | "locationKind" | "vendorName">): string {
  return bin.locationKind === "elevator" && bin.vendorName ? `${bin.name} (at ${bin.vendorName})` : bin.name;
}
